import { useEffect, useState } from 'react';

const STORAGE_KEY = 'hb_visitor_count';

function incrementOnEveryVisit(): number {
  const stored = localStorage.getItem(STORAGE_KEY);
  const count = stored ? parseInt(stored, 10) + 1 : 1248;
  localStorage.setItem(STORAGE_KEY, String(count));
  return count;
}

interface VisitorCounterProps {
  className?: string;
}

export default function VisitorCounter({ className = '' }: VisitorCounterProps) {
  const [count, setCount] = useState<number>(0);
  const [displayed, setDisplayed] = useState<number>(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const finalCount = incrementOnEveryVisit();
    setCount(finalCount);
  }, []);

  useEffect(() => {
    if (count === 0) return;
    const start = Math.max(count - 80, 0);
    let current = start;
    const step = Math.ceil((count - start) / 60);
    const timer = setInterval(() => {
      current += step;
      if (current >= count) {
        current = count;
        clearInterval(timer);
      }
      setDisplayed(current);
    }, 20);
    return () => clearInterval(timer);
  }, [count]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    const el = document.getElementById('visitor-counter-section');
    if (el) observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      id="visitor-counter-section"
      className={`flex items-center gap-3 ${className}`}
    >
      <div
        className={`flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2.5 transition-all duration-700 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-400"></span>
        </span>
        <span className="text-white text-sm font-medium whitespace-nowrap">
          <span className="font-bold text-green-300 text-base">{displayed.toLocaleString('fr-CH')}</span>
          {' '}visiteurs nous ont fait confiance
        </span>
      </div>
    </div>
  );
}
